import { createContext, ReactNode } from "react";

export enum DialogType {
    MESSAGE = 1,
    CONFIRMATION = 2,
}

interface DialogContextProps {
    dialogType: DialogType;
    setDialogType: any;
    showDialog: boolean;
    setShowDialog: any;
    title: string;
    setTitle: any;
    content: ReactNode;
    setContent: any;
    color: "error" | "success" | "info" | "warning" | "inherit" | "primary" | "secondary";
    setColor: any;
    verificationText: string;
    setVerificationText: any;
    okButtonTitle?: string;
    setOkButtonTitle: any;
    cancelButtonTitle?: string;
    setCancelButtonTitle: any;
    onClickOk: any;
    setOnClickOk: any;
    onClickCancel: any;
    setOnClickCancel: any;
}

const dialogContext = createContext<DialogContextProps>({
    dialogType: DialogType.MESSAGE,
    setDialogType: (dialogType: DialogType) => {
        return;
    },
    showDialog: false,
    setShowDialog: (showState: boolean) => {
        return;
    },
    title: "",
    setTitle: (title: string) => {
        return;
    },
    content: "",
    setContent: (content: string) => {
        return;
    },
    color: "primary",
    setColor: (color: string) => {
        return;
    },
    verificationText: "",
    setVerificationText: (verificationText: string) => {
        return;
    },
    okButtonTitle: "",
    setOkButtonTitle: (okButtonTitle: string) => {
        return;
    },
    cancelButtonTitle: "",
    setCancelButtonTitle: (closeButtonTitle: string) => {
        return;
    },
    onClickOk: () => {},
    setOnClickOk: (func: () => void) => {},
    onClickCancel: () => {},
    setOnClickCancel: (func: () => void) => {},
});

export default dialogContext;
